import React from 'react';

const HeartFilled: any = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14.96" height="12.35" viewBox="0 0 14.96 12.35" >
        <path id="Path_84467" data-name="Path 84467" d="M97.909,61.46a3.591,3.591,0,0,0-5.072,0l-1.358,1.359-1.361-1.361a3.586,3.586,0,0,0-5.072,5.072l6.087,6.087a.482.482,0,0,0,.687,0l6.087-6.087a3.581,3.581,0,0,0,0-5.069Z" transform="translate(-83.999 -60.41)" />
    </svg>
);


export default HeartFilled